// removed by extract-text-webpack-plugin
module.exports = {"heading":"styles__heading__1Y8kr","imageContainer":"styles__imageContainer__2vw-g","subTitle":"styles__subTitle__RWl4d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupTimeline/styles.scss
// module id = 420
// module chunks = 0